import List from '../../shared/styledComponents/List';
import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent(List, 'selectionField', ['list']);